import { initTracking, trackGA } from 'utilities/tracking';

const initGA = () => {
  if (Sq.Tracking.config.google_optimize) {
    trackGA('require', Sq.Tracking.config.google_optimize);
  }

  trackGA('require', 'ec');
  trackGA('set', 'currencyCode', Sq.Environment.currency_code);
};

initTracking().then(() => initGA());
